import { ApplicationsAPI } from '../apis';
import auth from '../common/Auth';

// Its retrive a list of application given its account's "id".
export const getApplicationByAccountId = ( accountId ) => {

    const token = auth.getAccessToken();
    const applicationAPI = new ApplicationsAPI(token, accountId);
    
    return applicationAPI.getAll(accountId);
    
};

export default getApplicationByAccountId;
